import { render } from "./BrandsSection.vue?vue&type=template&id=2cf3c24a&scoped=true&ts=true"
import script from "./BrandsSection.vue?vue&type=script&lang=ts"
export * from "./BrandsSection.vue?vue&type=script&lang=ts"

import "./BrandsSection.vue?vue&type=style&index=0&id=2cf3c24a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf3c24a"]])

export default __exports__